import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import {
  BuyerAccountV1Response,
  PaymentExecutionV1Request,
  PaymentExecutionV1Response,
  PaymentInquiryV1Response,
  PaymentPreviewHostedPaymentV1Response,
  PaymentPreviewV1Request,
  PaymentPreviewV1Response,
  PayOnAccountPaymentPreviewV1Request,
  PayOnAccountPaymentPreviewV1Response,
  PayOtherAmountV1ApiRequest,
  PayOtherAmountV1Response,
} from '../models';
import { PaymentInformationService } from './payment-information.service';

/* istanbul ignore next */
export class PaymentInformationPlatformService extends PaymentInformationService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  updateHostedPaymentPreviewV1() {
    return of();
  }

  updatePaymentPreviewV1(
    tenantId: string,
    paymentPreviewV1Request: PaymentPreviewV1Request,
  ): Observable<PaymentPreviewV1Response> {
    return this.httpClient.put<PaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/preview`,
      paymentPreviewV1Request,
    );
  }

  getHostedPaymentPreviewV1(): Observable<PaymentPreviewHostedPaymentV1Response> {
    return of(null);
  }

  getPaymentPreviewV1(tenantId: string, paymentReference: string) {
    return this.httpClient.get<PaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/preview/paymentreference/${paymentReference}`,
    );
  }

  getPayOnAccountPaymentPreviewV1(tenantId: string, paymentReference: string) {
    return this.httpClient.get<PayOnAccountPaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/preview/paymentreference/${paymentReference}`,
    );
  }

  executePaymentV1(
    tenantId: string,
    paymentReference: string,
    transactionReference: string,
    paymentExecutionV1Request: PaymentExecutionV1Request,
  ): Observable<PaymentExecutionV1Response> {
    return this.httpClient.post<PaymentExecutionV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/execution/paymentreference/${paymentReference}/transactionreference/${transactionReference}`,
      paymentExecutionV1Request,
    );
  }

  getBuyerAccountsV1(
    tenantId: string,
    externalUserUrn: string,
    originApplication: string,
  ) {
    const encodedUser = encodeURIComponent(externalUserUrn);
    const encodedApplication = encodeURIComponent(originApplication);
    return this.httpClient.get<BuyerAccountV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/user/${encodedUser}/buyer-account/application/${encodedApplication}`,
    );
  }

  GetPayOtherDocuments(
    tenantId: string,
    payOtherAmountV1ApiRequest: PayOtherAmountV1ApiRequest,
  ) {
    return this.httpClient.put<PayOtherAmountV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/payotheramount`,
      payOtherAmountV1ApiRequest,
    );
  }

  updatePaymentPreviewPayOnAccountV1(
    tenantId: string,
    payOnAccountPaymentPreviewV1Request: PayOnAccountPaymentPreviewV1Request,
  ) {
    return this.httpClient.put<PayOnAccountPaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/payonaccount/preview`,
      payOnAccountPaymentPreviewV1Request,
    );
  }

  getPaymentByReferenceV1(tenant: string, paymentReference: string) {
    return this.httpClient.get<PaymentInquiryV1Response>(
      `${this.baseUrl}/v1/tenants/${tenant}/paymentinquiry/paymentreference/${paymentReference}`,
    );
  }
}
